// extracted by mini-css-extract-plugin
module.exports = {"micro":"text_micro__Ul93G","small":"text_small__c4eBH","centered":"text_centered__hrOuH"};